(function () {
	'use strict';

	angular
	.module('core')
	.controller('baseCtrl', baseCtrl);

	baseCtrl.$inject = ['$http', '$scope', '$rootScope', '$q', '$timeout', '$route'];

	function getDaysAgo(b){
		var a = new Date();
		a.setDate(a.getDate() - b);
		return a;
	}

	document.head || (document.head = document.getElementsByTagName('head')[0]);

	function changeFavicon(src) {
		var oldLink = document.getElementById('dynamic-favicon1');
		if (oldLink) document.head.removeChild(oldLink);

		if(src != ''){
			var link = document.createElement('link');
			link.id = 'dynamic-favicon1';
			link.rel = 'shortcut icon';
			link.href = src+'?'+(new Date()).getTime();
			document.head.appendChild(link);
		}
	}

	function baseCtrl($http, $scope, $root, $q, $timeout, $route) {
		var vm = $scope;
		$root.route = $route;

		$root.math = Math;

		$root.tools = [
			{
				'name':'Live Recruitment Calculator',
				'slug':'live-recruitment'
			},{
				'name':'Card Organizer',
				'slug':'card-organizer'
			}
		]

		changeFavicon('./img/favicon.png');

		$(window).on('click', function(e){
			$timeout(function(){
				$root.$broadcast('documentClick');
			})
		});

		vm.init = function() {
			$http.get('./data/countries.json?t='+(new Date()).getTime()).
			then(function(response) {
				$root.countries = response.data;
			});
		}

		vm.init();
	}
})();